import { JsonApiRequestError, Mutation } from '@farfetched/core';
import { chain } from '@leprecoins/effector';
import { sample, Store } from 'effector';
import { AddCurrencyMutationParams, createAddCurrencyMutation, Currency } from 'shared/api';
import {
	createModalFormModel,
	maxLengthRule,
	minLengthRule,
	ModalFormModel,
	notify,
	onlyLatinRule,
} from 'shared/lib';

export type AddCurrencyFormValue = {
	code: string;
};

export type AddCurrencyModel = ModalFormModel<unknown, AddCurrencyFormValue> & {
	addCurrencyMutation: Mutation<AddCurrencyMutationParams, Currency, JsonApiRequestError>;
	$pending: Store<boolean>;
};

export const createAddCurrencyModel = (): AddCurrencyModel => {
	const model = createModalFormModel({
		fields: {
			code: {
				rules: [minLengthRule(3), maxLengthRule(4), onlyLatinRule],
				init: '',
			},
		},
		validateOn: ['submit'],
		resetErrorsOnChange: true,
	});

	const addCurrencyMutation = createAddCurrencyMutation();

	const { $pending } = addCurrencyMutation;

	sample({
		clock: model.form.submitted,
		source: model.form.$values,
		target: addCurrencyMutation.start,
	});

	chain(addCurrencyMutation.finished.success, model.switcher.disable);

	notify(addCurrencyMutation.finished.success, 'add-currency.success');

	chain(model.modalClosed, addCurrencyMutation.reset);

	return {
		addCurrencyMutation,
		$pending,
		...model,
	};
};
